import {
  PriceChange,
  Storage,
  Badge,
  AccountCircle,
  Storefront,
  Store,
  Extension,
  ShoppingCart,
  LocalOffer,
  AccountBalanceWallet
} from '@mui/icons-material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

export type FaqItem = {
  questionKey: string;
  answerKey: string;
};

export type FaqCategory = {
  id: string;
  titleKey: string;
  icon: OverridableComponent<SvgIconTypeMap> & { muiName: string };
  questions: FaqItem[];
};

export const faqCategories: FaqCategory[] = [
  {
    id: 'withdrawals',
    titleKey: 'faq.categories.withdrawals',
    icon: PriceChange,
    questions: [
      { questionKey: 'faq.withdrawals.q1', answerKey: 'faq.withdrawals.a1' }
    ]
  },
  {
    id: 'database',
    titleKey: 'faq.categories.database',
    icon: Storage,
    questions: [
      { questionKey: 'faq.database.q1', answerKey: 'faq.database.a1' }
    ]
  },
  {
    id: 'kyc',
    titleKey: 'faq.categories.kyc',
    icon: Badge,
    questions: [
      { questionKey: 'faq.kyc.q1', answerKey: 'faq.kyc.a1' }
    ]
  },
  {
    id: 'account',
    titleKey: 'faq.categories.account',
    icon: AccountCircle,
    questions: [
      { questionKey: 'faq.account.q1', answerKey: 'faq.account.a1' },
      { questionKey: 'faq.account.q2', answerKey: 'faq.account.a2' }
    ]
  },
  {
    id: 'market',
    titleKey: 'faq.categories.market',
    icon: Storefront,
    questions: [
      { questionKey: 'faq.market.q1', answerKey: 'faq.market.a1' }
    ]
  },
  {
    id: 'seller',
    titleKey: 'faq.categories.seller',
    icon: Store,
    questions: [
      { questionKey: 'faq.seller.q1', answerKey: 'faq.seller.a1' }
    ]
  },
  {
    id: 'extension',
    titleKey: 'faq.categories.extension',
    icon: Extension,
    questions: [
      { questionKey: 'faq.extension.q1', answerKey: 'faq.extension.a1' }
    ]
  },
  {
    id: 'buyer',
    titleKey: 'faq.categories.buyer',
    icon: ShoppingCart,
    questions: [
      { questionKey: 'faq.buyer.q1', answerKey: 'faq.buyer.a1' }
    ]
  },
  {
    id: 'offers',
    titleKey: 'faq.categories.offers',
    icon: LocalOffer,
    questions: [
      { questionKey: 'faq.offers.q1', answerKey: 'faq.offers.a1' }
    ]
  },
  {
    id: 'deposits',
    titleKey: 'faq.categories.deposits',
    icon: AccountBalanceWallet,
    questions: [
      { questionKey: 'faq.deposits.q1', answerKey: 'faq.deposits.a1' }
    ]
  }
];